import React, { useEffect, useState } from "react";
import { TaskAccordion } from "../components/taskAccordion";
import { addDays, isAfter, isBefore, isToday, isTomorrow } from "date-fns";
import { useTranslation } from "react-i18next";
import { useDates } from "../../../../hooks/useDates";
import { ProjectTaskDashboard } from "../../../../interfaces/Projects/projectTaskDashboard";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { FieldType } from "../../../../interfaces/Projects/Catalogs/fieldTypes";
import { useProjectTaskDashboardStore } from "../../../../store/Projects/ProjectTaskDashboard/ProjectTaskDashboardStore";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Box, Typography } from "@mui/material";

interface TableProjectTaskAccordionsProps {
  color: number[] | undefined;
  isEdit: boolean;
  resourceScreen: Menuitem;
  comboFieldTypes: FieldType[];
  isLoadingDataTable: boolean
}

export const TableProjectTaskAccordions = ({
  color,
  isEdit,
  resourceScreen,
  comboFieldTypes,
  isLoadingDataTable
}: TableProjectTaskAccordionsProps) => {
  const [todaysProjectTasks, setTodaysProjectTasks] = useState<ProjectTaskDashboard[]>([]);
  const [tomorrowsProjectTasks, setTomorrowsProjectTasks] = useState<ProjectTaskDashboard[]>([]);
  const [earlierProjectTasks, setEarlierProjectTasks] = useState<ProjectTaskDashboard[]>([]);
  const [laterProjectTasks, setLaterProjectTasks] = useState<ProjectTaskDashboard[]>([]);
  const [noDueDateTasks, setNoDueDateTasks] = useState<ProjectTaskDashboard[]>([]);
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(false);
  const [t] = useTranslation("global");
  const { TimeConverter } = useDates();
  const projectTasks = useProjectTaskDashboardStore(store => store.projectTasks)

  const categorizeTasks = async (tasks: ProjectTaskDashboard[]) => {
    const today = new Date();
    const yesterday = addDays(today, -1);
    const tomorrow = addDays(today, 1);

    const todaysTasks: ProjectTaskDashboard[] = [];
    const tomorrowsTasks: ProjectTaskDashboard[] = [];
    const earlierTasks: ProjectTaskDashboard[] = [];
    const laterTasks: ProjectTaskDashboard[] = [];
    const noDueDateTasksList: ProjectTaskDashboard[] = [];


    for (const task of tasks) {
      let dueDate;
      if (task.project_task_due_date_evaluated) {

        dueDate = TimeConverter(task.project_task_due_date_evaluated.toString());

      }

      if (dueDate) {
        if (isToday(dueDate)) {
          todaysTasks.push(task);
        } else if (isTomorrow(dueDate)) {
          tomorrowsTasks.push(task);
        } else if (isBefore(dueDate, yesterday)) {
          earlierTasks.push(task);
        } else if (isAfter(dueDate, tomorrow)) {
          laterTasks.push(task);
        }
      } else {
        noDueDateTasksList.push(task);
      }
    }

    setTodaysProjectTasks(todaysTasks);
    setTomorrowsProjectTasks(tomorrowsTasks);
    setEarlierProjectTasks(earlierTasks);
    setLaterProjectTasks(laterTasks);
    setNoDueDateTasks(noDueDateTasksList);
  };


  useEffect(() => {
    if (!isLoadingDataTable) {
      categorizeTasks(projectTasks)
    }
  }, [isLoadingDataTable, projectTasks]);

  return (
    <>
      {isLoadingDataTable && <Spinner />}
      {!isLoadingDataTable && projectTasks.length > 0 ? (
        <>
          <TaskAccordion title={t("projecttaskdashboard.accordions.earlier")}
            tasks={earlierProjectTasks}
            color={color}
            isEdit={isEdit}
            expanded={expandedAccordion === "earlier"}
            setExpandedAccordion={setExpandedAccordion}
            identifier="earlier"
            resourceScreen={resourceScreen}
            comboFieldTypes={comboFieldTypes}
          />
          <TaskAccordion title={t("projecttaskdashboard.accordions.today")}
            tasks={todaysProjectTasks}
            color={color}
            isEdit={isEdit}
            expanded={expandedAccordion === "today"}
            setExpandedAccordion={setExpandedAccordion}
            identifier="today"
            resourceScreen={resourceScreen}
            comboFieldTypes={comboFieldTypes}
          />
          <TaskAccordion title={t("projecttaskdashboard.accordions.tomorrow")}
            tasks={tomorrowsProjectTasks}
            color={color}
            isEdit={isEdit}
            expanded={expandedAccordion === "tomorrow"}
            setExpandedAccordion={setExpandedAccordion}
            identifier="tomorrow"
            resourceScreen={resourceScreen}
            comboFieldTypes={comboFieldTypes}
          />
          <TaskAccordion title={t("projecttaskdashboard.accordions.later")}
            tasks={laterProjectTasks}
            color={color}
            isEdit={isEdit}
            expanded={expandedAccordion === "later"}
            setExpandedAccordion={setExpandedAccordion}
            identifier="later"
            resourceScreen={resourceScreen}
            comboFieldTypes={comboFieldTypes}
          />
          <TaskAccordion title={t("projecttaskdashboard.accordions.no-date")}
            tasks={noDueDateTasks}
            color={color}
            isEdit={isEdit}
            expanded={expandedAccordion === "no-date"}
            setExpandedAccordion={setExpandedAccordion}
            identifier="no-date"
            resourceScreen={resourceScreen}
            comboFieldTypes={comboFieldTypes}
          />
        </>
      ) : (
        <Box
          sx={{
            justifyContent: "center",
            marginBlock: 2,
            display: "flex",
          }}
        ><Typography>{t('projecttaskdashboard.messages.no-tasks')}</Typography></Box>
      )}

    </>
  );
};
